/* eslint-disable security/detect-object-injection */
/* eslint-disable max-len */
import React, { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";

export default function Sidebar() {
    const [selectedOption, setSelectedOption] = useState("dashboard");
    const location=useLocation();
    
    const navigate = useNavigate();

    const sideNavObject={
        'Dashboard':{
            "path":'/',
            img:`/assets/images/${!location.pathname.includes('/')?'dashboard.svg':'user-active.svg'}`,
            mainClass:`${location.pathname.includes('')?'bg-primary ':''}`,
            ptag: `${location.pathname.includes('/') ?'text-[#9C2363]':'text-[#4B4B4B]'}`
        },
        'Admin Users':{
            "path":'/manage-admin-users',
            img:`/assets/images/${!location.pathname.includes('/manage-admin-users')?'whiteusers.svg':'user-active.svg'}`,
            mainClass:`${location.pathname.includes('/manage-admin-users')?'bg-primary ':''}`,
            ptag: `${location.pathname.includes('/manage-admin-users') ?'text-[#9C2363]':'text-[#4B4B4B]'}`
        },
        'Merchants':{
            "path":'/manage-merchants',
            img:`/assets/images/${!location.pathname.includes('/manage-merchants')?'users.svg':'active-merchant.svg'}`,
            mainClass:`${location.pathname.includes('/manage-merchants')?'bg-primary ':''}`,
            ptag: `${location.pathname.includes('/manage-merchants') ?'text-[#9C2363]':'text-[#4B4B4B]'}`
        },
        'Orders/Purchases':{
            "path":'/Orders/Purchases',
            img:`/assets/images/${!location.pathname.includes('/Orders/Purchases')?'basket-icon 1.svg':'user-active.svg'}`,
            mainClass:`${location.pathname.includes('/Orders/Purchases')?'bg-primary ':''}`,
            ptag: `${location.pathname.includes('/Orders/Purchases') ?'text-[#9C2363]':'text-[#4B4B4B]'}`
        },
        'payouts':{
            "path":'/payouts',
            img:`/assets/images/${!location.pathname.includes('/payouts')?'basket-icon 1.svg':'smile.svg'}`,
            mainClass:`${location.pathname.includes('/payouts')?'bg-primary ':''}`,
            ptag: `${location.pathname.includes('/payouts') ?'text-[#9C2363]':'text-[#4B4B4B]'}`
        },
        'supports':{
            "path":'/supports',
            img:`/assets/images/${!location.pathname.includes('/supports')?'basket-icon 1.svg':'like.svg'}`,
            mainClass:`${location.pathname.includes('/supports')?'bg-primary ':''}`,
            ptag: `${location.pathname.includes('/supports') ?'text-[#9C2363]':'text-[#4B4B4B]'}`
        },
        'Returns and Refunds':{
            "path":'/Returns and Refunds',
            img:`/assets/images/${!location.pathname.includes('/Returns and Refunds')?'basket-icon 1.svg':'lisaving-icon 1.svg'}`,
            mainClass:`${location.pathname.includes('/Returns and Refunds')?'bg-primary ':''}`,
            ptag: `${location.pathname.includes('/Returns and Refunds') ?'text-[#9C2363]':'text-[#4B4B4B]'}`
        },
        'Reports':{
            "path":'/Reports',
            img:`/assets/images/${!location.pathname.includes('/Reports')?'basket-icon 1.svg':'reports-icon 1.svg'}`,
            mainClass:`${location.pathname.includes('/Reports')?'bg-primary ':''}`,
            ptag: `${location.pathname.includes('/Reports') ?'text-[#9C2363]':'text-[#4B4B4B]'}`
        }
        
    }

    return (
        <div className="h-[100vh] bg-[#fff] w-fit flex flex-col">
            {/* <div className="w-fit h-full"> */}
            <div className="bg-primary pl-[24px] pr-[37px] py-[41px] ">
                <h1 className="text-xl text-white font-medium">
                    Maison QR | <span className="text-base">Admin</span>
                </h1>
            </div>
            <div className="mt-[14px] bg-white  flex flex-col justify-between pb-[18px] grow">
                <ul className="px-[12px]">
                    {Object.keys(sideNavObject).map((nav)=>(
                        <li key={nav} onClick={()=>navigate(sideNavObject[nav].path)} className={`mt-[4px] pl-2 py-[17px]  flex space-x-2 ${sideNavObject[nav].mainClass}  items-center cursor-pointer`}>
                            <img
                                src={sideNavObject[nav].img}
                                alt={nav}
                            />
                            <p className={`font-crimson ${sideNavObject[nav].ptag} text-base font-normal`}>{nav}</p>
                        </li>
                    ))}
                    
                </ul>
                <div className="px-3 cursor-pointer" onClick={()=>dispactch(logout())}>
                    <div className=" flex space-x-[13px] justify-center items-center border-[1px] rounded-[4px] pr-[10px] pl-[7px] py-[10px] border-primary">
                        <h1 className="px-[11px] py-[11px] text-base font-semibold text-white leading-6 bg-primary rounded-full">
                            EJ
                        </h1>
                        <p className="text-base text-[#4B4B4B] font-normal">
                            Emily Johnson
                        </p>
                        <img src="/assets/images/chevron-right.svg" alt="" />
                    </div>
                </div>
            </div>
        </div>
    );
}
